import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["label"];

  connect() {
    this.change();
  }

  change() {
    this.labelTargets.forEach((label) => {
      const input = label.querySelector("input");
      if (input.checked) {
        this.check(label);
      } else {
        this.uncheck(label);
      }
    });
  }

  check(target) {
    target.classList.remove("border-gray-200");
    target.classList.add("bg-teal-50", "border-teal-200", "z-10");

    const title = target.querySelector('span[data-radio-group-target="title"]');
    title.classList.add("text-teal-900");
    title.classList.remove("text-gray-900");

    const subtitle = target.querySelector(
      'span[data-radio-group-target="subTitle"]'
    );
    subtitle.classList.add("text-teal-700");
    subtitle.classList.remove("text-gray-500");
  }

  uncheck(target) {
    target.classList.remove("bg-teal-50", "border-teal-200", "z-10");
    target.classList.add("border-gray-200");

    const title = target.querySelector('span[data-radio-group-target="title"]');
    title.classList.remove("text-teal-900");
    title.classList.add("text-gray-900");

    const subtitle = target.querySelector(
      'span[data-radio-group-target="subTitle"]'
    );
    subtitle.classList.remove("text-teal-700");
    subtitle.classList.add("text-gray-500");
  }
}
